import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IWaitingRoomMember } from '@gem/call/Model/callModel.types';
import { Avatar, AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { useWaitingRoomMemberCardPresenter } from './WaitingRoomMemberCard.presenter';
import styles from './WaitingRoomMemberCard.styles.m.css';

interface IWaitingRoomMemberCardProps {
  member: IWaitingRoomMember;
}

export const WaitingRoomMemberCard: FC<IWaitingRoomMemberCardProps> = observer(({ member }) => {
  const presenter = useWaitingRoomMemberCardPresenter(member);

  return (
    <div
      id={member.memberId}
      className={styles.memberCardContainer}
    >
      <div className={styles.avatarContainer}>
        <Avatar
          type={AvatarTypes.Round_10}
          title={member.displayData.userName}
          url={member.displayData.avatarUrl}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>
          <span className={styles.titleName}>{member.displayData.userName}</span>
        </div>
      </div>
      <div className={styles.actions}>
        {presenter.actions.map((action) => (
          <IconButton
            key={action.key}
            Icon={action.icon}
            onClick={action.onClick}
            className={styles.action}
            size={IconViewSizes.Big}
            iconSize={IconViewSizes.Medium}
            theme="11"
          />
        ))}
      </div>
    </div>
  );
});
